import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { confirmSoftAgeVerification, isSoftAgeVerificationConfirmed } from "@jti/fe-common";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { LanguageSelector } from "../../components/LanguageSelector";
import { useCurrentBreakpoint } from "../../hooks/useCurrentBreakpoint";
import { BACKGROUND_OPTIONS, Dialog } from "../../components/Dialog";
import { Form, useForm } from "../../components/Form";
import { Logo } from "../Logo";
import styles from "./SoftAgeVerification.module.scss";
export const SoftAgeVerification = ({ portalDomNode = document.body, languages, backgroundColor = "blurredWhite", theme = "light", logo, children, isAuthorMode, isBodyScrollDisabled, isLogoEnabled = true, shouldPageReload = false, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { mainBreakpoint } = useCurrentBreakpoint();
    const [noContent, setNoContent] = useState(false);
    useEffect(() => {
        const isAgeConfirmed = isSoftAgeVerificationConfirmed();
        if (!isAgeConfirmed || isAgeConfirmed === "false") {
            setIsOpen(true);
        }
    }, []);
    const birthForm = useForm({
        mode: "onTouched",
        defaultValues: {
            day: "",
            month: "",
            year: "",
        },
    });
    const verifyAge = () => {
        dispatchTrackingEvent(TrackingEvents.TrackingAgeVerificationClick, {
            age_confirmation: "yes",
        });
        confirmSoftAgeVerification();
        if (shouldPageReload) {
            setNoContent(true);
            window.location.reload();
        }
        else {
            setIsOpen(false);
        }
    };
    return (_jsxs(Dialog, { dataTestId: "soft-age-verification-dialog", theme: theme, closable: false, isOpened: isOpen, fullscreen: mainBreakpoint === "xs", backgroundBlur: BACKGROUND_OPTIONS[backgroundColor].blur, backgroundColor: BACKGROUND_OPTIONS[backgroundColor].color, portalDomNode: portalDomNode, className: styles.ageConfirmationDialog, isUnwrapped: isAuthorMode, isBodyScrollDisabled: isBodyScrollDisabled, noPadding: true, noContent: noContent, children: [_jsx("div", { className: styles.softAgeVerificationLanguageSelector, children: _jsx(LanguageSelector, { popupContext: "AGE_CONFIRMATION", variant: ["md", "lg"].includes(mainBreakpoint) ? "SHORT_LANGUAGE_NAME" : "FULL_LANGUAGE_NAME", languages: languages || [] }) }), _jsxs("div", { className: styles.ageConfirmationContent, children: [isLogoEnabled && _jsx(Logo, { ...logo, isDarkMode: theme === "dark", className: styles.logo }), _jsx(Form, { form: birthForm, onSubmit: verifyAge, children: _jsx("div", { className: styles.ageConfirmationChildren, children: children }) })] })] }));
};
//# sourceMappingURL=SoftAgeVerification.js.map